<template>
  <div v-if="user" class="c-header-nav-items header-account-dropdown">
    <router-link class="d-flex align-items-center me-2" to="/user-settings">
      <div v-if="showPhoto" class="c-avatar me-1 me-sm-3">
        <div class="settings-link">
          <i class="flaticon-settings" />
        </div>
        <img
          :src="user.avatar ? user.avatar : '/img/avatars/user-avatar.jpeg'"
          class="c-avatar-img user-avatar-image"
          data-test-id="header-user-avatar"
        />
      </div>
      <div class="user-info" data-test-id="student-profile-settings">
        <div class="name" data-test-id="header-user-names">
          {{ user.first_name + " " + user.last_name }}
        </div>
        <b>Profile settings</b>
      </div>
    </router-link>
  </div>
</template>

<script>
import { mapGetters } from "vuex"

export default {
  name: "TheHeaderDropdownAccnt",
  props: ["user"],
  data() {
    return {
      itemsCount: 42
    }
  },
  computed: {
    ...mapGetters({
      showStudentPhotos: "schools/showStudentPhotos",
      isStudent: "authentication/isStudent"
    }),
    showPhoto() {
      return !this.isStudent || this.showStudentPhotos
    }
  },
  methods: {
    logout() {
      this.$store.dispatch("authentication/logOut")
    }
  }
}
</script>

<style lang="scss" scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>
